import Axios from 'axios';
import { API_URL } from './constants';

// eslint-disable-next-line import/prefer-default-export
export const getJob = (jobId) => Axios.post(`${API_URL}/users/get-async-job-by-id`, { jobId }, {
  headers: {
    sessionId: localStorage.getItem('sessionId'),
  },
});
